import React            from 'react';
import PropTypes        from 'prop-types';
import { 
    Container,
    Wrapper,
    ContentWrapper,
    Base,
    Helper,
    Label,
    Counter
}                       from './components';

class Textarea extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            type            : props.type,
            charLeft        : props.maxLength,
            value           : '',
            isFocused       : false,
            patterns        : {
                    tel         : '[0-9]*',
            },
            errors          : props.errors
        };

        this.base = React.createRef();

        this.onChangeHandler    = this.onChangeHandler.bind(this);
        this.onClickHandler     = this.onClickHandler.bind(this);
        this.onBlurHandler      = this.onBlurHandler.bind(this);
    }

    createComponentClasses() {
        let {
            required,
            colorType,
            full,
            className,
        } = this.props;
        let {
            errors
        } = this.state;

        let classNames = ['simprakit-textarea'];
        if (required)                                  classNames.push('required');
        if (errors)                                    classNames.push('danger')
        if (!errors && colorType)                      classNames.push(colorType);
        if (full)                                      classNames.push('full');
        if (className)                                 Array.prototype.push.apply(classNames, className.split(' '));

        return [...new Set(classNames)].join(' ');
    }

    componentDidMount(){
        let s = this.state;
        let p = this.props;
        let defaultValue = p.value !== undefined
                                ? p.value
                                : '';
        let lengthOfValue = p.value 
                                ? p.maxLength - p.value.length 
                                : 0;
        this.setState({
            charLeft        : lengthOfValue,
            value           : defaultValue
        }, () => {
            if(p.autoFocus)
                this.refs.BASE.refs.INPUT.focus();
        });
    }

    componentDidUpdate(prevProps, _prevState) {
        if(prevProps.value !== this.props.value || prevProps.optionValue !== this.props.optionValue) {
            this.setState({
                value : this.props.value !== undefined
                        ? this.props.value
                        : '',
            });
        }

        if(prevProps.errors !== this.props.errors) {
            this.setState({ 
                errors       : this.props.errors
            });
        }
    }

    isInteractive() { return !this.props.isDisabled && !this.props.isLoading; }

    onChangeHandler(e) {
        e.persist();
        let { maxLength, onChange } = this.props;

        if(!this.checkValidity(e) || this.isAvailableValidation(e.target)) {
            this.setState({
                charLeft : maxLength - e.target.value.length,
                value    : e.target.value,
                errors   : null
            }, () => {
                if(onChange)
                    onChange(e.target.value);
            });
        }
    }

    isAvailableValidation(field) {
        let {
            minLength
        } = this.props;
        return  field.value.length === 0 ||  minLength
    }

    onClickHandler(e) {
        let p = this.props;
        if(!this.isInteractive()) {
            e.stopPropagation();
            return;
        }
        this.refs.BASE.refs.INPUT.focus();
        this.setState({ 
            isFocused: true,
            errors: null,
        }, () => {
            if(p.onClick)
                p.onClick();
        });
    }

    onBlurHandler(e) {
        let p = this.props;
        e.stopPropagation();
        this.setState({ 
            isFocused   : false
        }, () => {
            if(p.onBlur)
                p.onBlur();          
        });
        this.checkValidity(e);
    }

    onKeyUpHandler(e){
        let p = this.props;
        if(p.onKeyUp)
            p.onKeyUp(e);
    }

    onKeyDownHandler(e){
        let p = this.props;
        if(p.onKeyUp)
            p.onKeyDown(e);
    }

    checkValidity(event) {
        let {
            required,
            maxLength,
            minLength,
        } = this.props;
        let errors = [];
        let { validity } = event.target;

        // Don't validate if is isDisabled or isLoading
        if(!this.isInteractive()) return;

        // If valid, return null
        if(validity.valid) return;

        // If field is required and empty
        if(required && validity.valueMissing) 
            errors.push({ type: 'required', message: 'Please fill out this field.' });

        // If too short
        if (minLength && validity.tooShort) 
            errors.push({ type: 'minLength', message: 'Please lengthen this text.' });
        
        // If too long
        if (maxLength && validity.tooLong) 
            errors.push({ type: 'maxLength', message: 'Please shorten this text.' });

        if(errors.length > 0)
            this.setState({
                errors,
            });
            
        return errors;
    }

    createCounterComponent() {
        let p = this.props;
        let s = this.state;
        if(p.maxLength)
            return (
                <Counter
                    isFocused   = { s.isFocused }
                    charLeft    = { s.charLeft }
                    maxLength   = { p.maxLength }
                />
            );

        return null;
    }

    render(){
        let p       = this.props;
        let s       = this.state;
        return(
            <Container className= { this.createComponentClasses() }>
                <Label>{ p.label }</Label>
                <Wrapper
                    isDisabled          = { p.isDisabled }
                    isFocused           = { s.isFocused }
                >
                    <ContentWrapper>
                        <Base 
                            type            = { s.type }
                            placeholder     = { p.placeholder }
                            tabIndex        = { p.tabIndex }
                            attrs           = { p.attrs }
                            value           = { s.value === null ? '' : s.value }
                            ref             = 'BASE'
                            rows            = { p.rows }
                            maxLength       = { p.maxLength }
                            isDisabled      = { p.isDisabled }
                            required        = { p.required }
                            onClick         = { e => this.onClickHandler(e) }
                            onBlur          = { e => this.onBlurHandler(e) }
                            onChange        = { e => this.onChangeHandler(e) }
                            onFocus         = { e => this.onClickHandler(e) }
                            onKeyUp         = { e => this.onKeyUpHandler(e) }
                            onKeyDown       = { e => this.onKeyDownHandler(e) }
                        />
                        <Helper 
                            isFocused           = { s.isFocused } 
                            isDisabled          = { p.isDisabled }
                            text                = { s.errors ? s.errors[0].message : p.helper } 
                        />
                    </ContentWrapper>
                    { this.createCounterComponent() }
                </Wrapper>
            </Container>
        )
    }
}

Textarea.propTypes = {
    label           : PropTypes.string,
    type            : PropTypes.oneOf(['text', 'password','email','phone','number', 'date', 'tel', 'url']),
    helper          : PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
    placeholder     : PropTypes.string,
    full            : PropTypes.bool,
    isDisabled      : PropTypes.bool,
    tabIndex        : PropTypes.string,
    autoFocus       : PropTypes.bool,
    attrs           : PropTypes.object,
    className       : PropTypes.string,
    size            : PropTypes.string,
    required        : PropTypes.bool,
    options         : PropTypes.array,
    optionValue     : PropTypes.string,
    rows            : PropTypes.number,
    onChange        : PropTypes.func,
    onClick         : PropTypes.func,
    onBlur          : PropTypes.func,
    onKeyUp         : PropTypes.func,
    onKeyDown       : PropTypes.func,
    onSelect        : PropTypes.func,
};

Textarea.defaultProps = {
    label           : '',
    full            : false,
    helper          : '',
    tabIndex        : '',
    placeholder     : '',
    isDisabled      : false,
    autoFocus       : false,
    size            : '',
    colorType       : '',
    className       : '',
    required        : false,
    attrs           : {},
    options         : [],
    optionValue     : null,
    rows            : 3,
    onChange        : ()=>{},
    onClick         : ()=>{},
    onKeyUp         : ()=>{},
    onKeyDown       : ()=>{},
    onBlur          : ()=>{},
    onSelect        : ()=>{} 
};

export default Textarea;